import { registerComponent, loading, executeScripts } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "adoption-search-textbook-results",
  class AdoptionSearchTextbookResults extends WYATTElement {
    constructor() {
      super();

      this.resultsElement = this.querySelector(".adoption-search__results");
    }

    connectedCallback() {
      loading.add(this);
    }

    disconnectedCallback() {
      loading.remove(this);
    }

    get templates() {
      return {
        textbookSection: document.getElementById(
          "adoption-search-textbook-section"
        ).content,
        textbookItem: document.getElementById("adoption-search-textbook-item")
          .content,
        textbookNoResults: document.getElementById(
          "adoption-search-textbook-no-results"
        ).content,
      };
    }

    buildCourseDataByCourseId(data) {
      return data.items.reduce((acc, item) => {
        acc[item.course_id] = item;
        return acc;
      }, {});
    }

    render(textbookData, productTemplatesByCourseId, courseIds) {
      loading.remove(this);

      const courseDataByCourseId = this.buildCourseDataByCourseId(textbookData);

      courseIds.forEach((courseId) => {
        const textbookSectionElement =
          this.templates.textbookSection.cloneNode(true);

        const dataItem = courseDataByCourseId[courseId];
        const productTemplates = productTemplatesByCourseId[courseId];

        textbookSectionElement.querySelector(
          ".adoption-search__textbook-section"
        ).id = dataItem.course_id;

        textbookSectionElement.querySelector(
          ".adoption-search__textbook-course-name"
        ).textContent = dataItem.course_name;

        textbookSectionElement.querySelector(
          ".adoption-search__textbook-course-number"
        ).textContent = dataItem.class_nbr;

        if (productTemplates.length > 0) {
          productTemplates.forEach((productTemplate) =>
            textbookSectionElement
              .querySelector(".adoption-search__textbook-list")
              .appendChild(this.renderTextbookItem(productTemplate))
          );
        } else {
          const noResultsElement =
            this.templates.textbookNoResults.cloneNode(true);

          textbookSectionElement
            .querySelector(".adoption-search__textbook-list")
            .appendChild(noResultsElement);
        }

        this.resultsElement.appendChild(textbookSectionElement);
      });
    }

    renderTextbookItem(productTemplate) {
      const textbookItemElement = this.templates.textbookItem.cloneNode(true);

      // Parse the HTML string into a document fragment
      const parser = new DOMParser();
      const doc = parser.parseFromString(productTemplate, "text/html");
      const contentNodes = Array.from(doc.body.childNodes);

      const container = textbookItemElement.querySelector(
        ".adoption-search__textbook-item"
      );

      // Append all nodes to the container
      contentNodes.forEach((node) => {
        container.appendChild(node);
      });

      // Execute any scripts in the container
      executeScripts(container);

      return textbookItemElement;
    }
  }
);
